import { SectionKind, type SectionType } from "components/server-types";

export const isLinkedSection = (section: SectionType | null | undefined) => {
  return section?.kind === SectionKind.LINKED;
};

export const isTemplateSection = (section: SectionType | null | undefined) => {
  return section?.kind === SectionKind.TEMPLATE;
};

export const isUnlinkedSection = (section: SectionType | null | undefined) => {
  return section?.kind === SectionKind.UNLINKED;
};
